import { getBackVersion } from '../../../config';
import api from '../../api';
import { RentAdvanceRequestSnapshot } from '../../../models/LandlordArea/RentAdvance';
import { decamelizeKeys } from '../../../lib';

const getById = (id: number): Promise<RentAdvanceRequestSnapshot> =>
    api.request<RentAdvanceRequestSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/landlord_area/rent_advances/${id}`,
    });

const getByContractId = (
    contractId: string
): Promise<RentAdvanceRequestSnapshot> =>
    api.request<RentAdvanceRequestSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/landlord_area/contracts/${contractId}/rent_advance`,
    });

const submitAdvance = (
    id: number,
    offerId: number
): Promise<RentAdvanceRequestSnapshot> =>
    api.request<RentAdvanceRequestSnapshot>({
        method: 'PUT',
        url: `${getBackVersion()}/landlord_area/rent_advances/${id}`,
        data: decamelizeKeys({
            offerId,
            status: 'requested',
        }),
    });

const createAdvance = (
    contractId: string
): Promise<RentAdvanceRequestSnapshot> =>
    api.request<RentAdvanceRequestSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/landlord_area/rent_advances`,
        data: decamelizeKeys({ contractId }),
    });

export { getById, getByContractId, createAdvance, submitAdvance };
